import React from 'react';
import { OriSelect } from 'src/components/Antd';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { Field } from 'src/components/RcForm';
import {
  contentPagesToShow,
  productToShow,
} from 'src/tools/contentModulesFieldName';
//import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { sectionProps } from 'src/tools/constant';
import { i18nGet } from 'src/tools/tools';
import { EnumModuleType } from 'src/types/common/module';
const Option = OriSelect.Option;

const ItemToShow = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disabled, options, moduleType } = props;
  const titleGenerator = () => {
    if (moduleType === EnumModuleType.ResponsiveProductCarousel) {
      return getI18n('general.productsToShow');
    }
    if (moduleType === EnumModuleType.ResponsiveContentCarousel) {
      return getI18n('general.contentPagesToShow');
    }
  };
  const nameGenerator = () => {
    if (moduleType === EnumModuleType.ResponsiveProductCarousel) {
      return productToShow;
    }
    if (moduleType === EnumModuleType.ResponsiveContentCarousel) {
      return contentPagesToShow;
    }
  };
  return (
    <Section {...sectionProps}>
      <ItemWrapper title={titleGenerator()}>
        <Field name={nameGenerator()}>
          <OriSelect
            disabled={disabled}
            size='large'
            //   value={moduleWidth}
            //   onChange={handleOnModuleWidthChange}
          >
            {options.map((i) => {
              const { label, value } = i;
              return (
                <Option value={value} key={value}>
                  {label}
                </Option>
              );
            })}
          </OriSelect>
        </Field>
      </ItemWrapper>
    </Section>
  );
};
export default ItemToShow;
